import { SidebarMenuFooterContainer } from './styled';
export function SidebarMenuFooter(props) {
    const { children } = props;
    return <SidebarMenuFooterContainer>{children}</SidebarMenuFooterContainer>;
}
